import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logo-casa-do-software-cortada.png?v=2")